/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DeverbChanelFragment = {
	id: string;
	description: {
		constraints: { deverb: { intensity: { options: Array<Types.DeverbIntensity> } } | null };
		features: { channelConfiguration: { supported: boolean } };
	};
	features: {
		name: { name: string } | null;
		deverb: { enabled: boolean; intensity: Types.DeverbIntensity } | null;
		channelConfiguration: { enabled: boolean } | null;
	};
};

export type DeverbChannelUpdateFragment = {
	id: string;
	features:
		| { channelConfiguration: { enabled: boolean } | null }
		| { deverb: { enabled: boolean; intensity: Types.DeverbIntensity } | null }
		| { name: { name: string } | null }
		| {};
};

export type DeverbChannelQueryVariables = Types.Exact<{
	channelId: Types.Scalars['ID']['input'];
}>;

export type DeverbChannelQueryOpResult = { node: DeverbChanelFragment | {} };

export type DeverbChananelSubscriptionVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;

export type DeverbChananelSubscriptionOpResult = {
	nodeChanges: DeverbChanelFragment | DeverbChannelUpdateFragment | {};
};

export type DeverbChannelMutationVariables = Types.Exact<{
	updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type DeverbChannelMutationOpResult = {
	updateNodes: Array<{ error: { code: Types.ErrorCode; message: string } | null } | {}>;
};

export const DeverbChanelFragment = gql`
	fragment DeverbChanelFragment on AudioChannel {
		id
		description {
			constraints {
				deverb {
					intensity {
						options
					}
				}
			}
			features {
				channelConfiguration {
					supported
				}
			}
		}
		features {
			name {
				name
			}
			deverb {
				enabled
				intensity
			}
			channelConfiguration {
				enabled
			}
		}
	}
`;
export const DeverbChannelUpdateFragment = gql`
	fragment DeverbChannelUpdateFragment on AudioChannelChange {
		id
		features {
			... on AudioChannelNameChange {
				name {
					name
				}
			}
			... on AudioChannelDeverbChange {
				deverb {
					enabled
					intensity
				}
			}
			... on AudioChannelChannelConfigurationChange {
				channelConfiguration {
					enabled
				}
			}
		}
	}
`;
export const DeverbChannelQueryDocument = gql`
	query DeverbChannelQuery($channelId: ID!) {
		node(id: $channelId) {
			...DeverbChanelFragment
		}
	}
	${DeverbChanelFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class DeverbChannelQueryGQL extends Apollo.Query<DeverbChannelQueryOpResult, DeverbChannelQueryVariables> {
	override document = DeverbChannelQueryDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const DeverbChananelSubscriptionDocument = gql`
	subscription DeverbChananelSubscription($id: ID!, $types: [NodeChangeType!]!) {
		nodeChanges(id: $id, types: $types) {
			... on AudioChannel {
				...DeverbChanelFragment
			}
			... on AudioChannelChange {
				...DeverbChannelUpdateFragment
			}
		}
	}
	${DeverbChanelFragment}
	${DeverbChannelUpdateFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class DeverbChananelSubscriptionGQL extends Apollo.Subscription<
	DeverbChananelSubscriptionOpResult,
	DeverbChananelSubscriptionVariables
> {
	override document = DeverbChananelSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const DeverbChannelMutationDocument = gql`
	mutation DeverbChannelMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
		updateNodes(updates: $updates, keyring: $injectKeyring) {
			... on AudioChannelOperationResult {
				error {
					code
					message
				}
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class DeverbChannelMutationGQL extends Apollo.Mutation<
	DeverbChannelMutationOpResult,
	DeverbChannelMutationVariables
> {
	override document = DeverbChannelMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
